export const NoValue = '—';
